import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Login from '../component/Login/login';
import Error from '../component/Error/Error';
import EmailHidden from '../component/EmailHidden/Instruction';
import Home from '../component/home';
import { Bounce, ToastContainer } from 'react-toastify';
import tokenService from "../service/token.service";
import RestartPage from "../component/RestartPage/RestartPage";

function NavRouter(props) {
const renderScreen = () => {
  const isPrivateEmail = tokenService.isPrivateEmail();
  const visitedTime = localStorage.getItem("visitedEmailHidden");

  if (isPrivateEmail) {
    if (visitedTime) {
      return <RestartPage />
    }
    return <EmailHidden />;
  }

  return <Home />;
};

    return (
        <Router>
            <ToastContainer 
                limit={1}
                position="top-right"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
                transition={Bounce}
            />
            <Routes>
                {
                    props.navigationCase ?
                        <Route exact path="/" element={<Error />} />
                        :
                        <Route exact path="/" element={renderScreen()} />
                }
                <Route exact path="login" element={<Login />} />
                <Route exact path="/restartPage" element={<RestartPage/>} />
            </Routes>
        </Router>
    );
}

export default NavRouter;
